var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved
import { forwardRef } from 'react';
import { Background, BorderSize, Foreground, State } from '@front/sharedcomponents/Styles';
import { SvgIcon } from '../../SvgIcon/SvgIcon';
import { SvgIconType } from '../../SvgIcon/SvgIconType';
import { TooltipDecorator } from '../../Tooltip/TooltipDecorator';
import { Typography } from '../../Typography/Typography';
import { TypographyLevel } from '../../Typography/TypographyLevel';
import '@styles/webdesktop/stylesheets/contextMenuItem.scss';
export const ContextMenuItem = forwardRef((_a, ref) => {
    var { text, hasLeftOffset = false, hasRightOffset = false, hasSubitems = false, tooltip = null, icon = null, disabled = false, disabledReason = null, checked = false, selected = false, isBeta = false, onClick, onPointerEnter } = _a, restItemProps = __rest(_a, ["text", "hasLeftOffset", "hasRightOffset", "hasSubitems", "tooltip", "icon", "disabled", "disabledReason", "checked", "selected", "isBeta", "onClick", "onPointerEnter"]);
    const renderIcon = () => {
        if (!hasLeftOffset) {
            return null;
        }
        let iconType = null;
        if (checked) {
            iconType = SvgIconType.Checkbox;
        }
        else if (disabled && isValidString(disabledReason)) {
            iconType = SvgIconType.MenuError;
        }
        else {
            iconType = icon;
        }
        return (_jsx("div", { className: "context-menu-item-icon", children: _jsx(SvgIcon, { icon: iconType }) }));
    };
    const renderText = () => {
        return (_jsx("div", { className: "context-menu-item-text", children: _jsx(Typography, { level: TypographyLevel.BodyMd, noWrap: true, children: text }) }));
    };
    const renderSubitems = () => {
        if (!hasRightOffset) {
            return null;
        }
        return (_jsx("div", { className: "context-menu-item-subitems", children: hasSubitems && _jsx(SvgIcon, { icon: SvgIconType.ArrowRight }) }));
    };
    const handlePointerEnter = (event) => {
        if (disabled) {
            return;
        }
        onPointerEnter === null || onPointerEnter === void 0 ? void 0 : onPointerEnter(event.currentTarget);
    };
    const handleClick = () => {
        if (disabled) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const handleKeyDown = (e) => {
        if (disabled) {
            return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };
    const classNames = [
        'context-menu-item',
        selected ? Foreground.Primary : Foreground.Secondary,
        selected ? Background.Primary : Background.Secondary,
        BorderSize.None,
        disabled ? State.Disabled : ''
    ];
    const className = classNames.filter(Boolean).join(' ');
    return (_jsx(TooltipDecorator, { content: disabled && isValidString(disabledReason) ? disabledReason : tooltip, children: _jsxs("li", Object.assign({ ref: ref, role: "menuitem" /* NOSONAR S6842 - li as menuitem with role is intentional */, className: className, tabIndex: disabled ? -1 : 0, onClick: handleClick, onKeyDown: handleKeyDown, onPointerEnter: handlePointerEnter, "aria-disabled": disabled }, restItemProps, { children: [renderIcon(), renderText(), renderSubitems(), isBeta && _jsx(SvgIcon, { icon: SvgIconType.Beta })] })) }));
});
